import { atom } from 'recoil'
import {
  BusinessUnitEntity
} from 'common/types/odino/built-in/entities/business-unit-entity'

export const businessUnitsState = atom<BusinessUnitEntity>({
  key: 'business-units',
  default: undefined
})
